import React, { useState, useEffect } from "react";
import { Routes, Route, Navigate, useNavigate, useLocation } from "react-router-dom";
import "./MaintenanceLayout.css";
import Sidebar, { SidebarMenuItem } from "../components/Sidebar";
import MaintenanceHistoryView from "./MaintenanceHistoryView";
import SalesValuationView from "./SalesValuationView";
import DrivingManagementView from "../operation/driving/DrivingManagementView";
import { Vehicle } from "../data/database";

interface MaintenanceLayoutProps {
    vehicles: Vehicle[];
}

const linkageMenuItems: SidebarMenuItem[] = [
    {
        id: "driving",
        label: "운행 기록",
        icon: (
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M12 2L2 7l10 5 10-5-10-5z"></path>
                <path d="M2 17l10 5 10-5"></path>
                <path d="M2 12l10 5 10-5"></path>
            </svg>
        ),
    },
    {
        id: "sales",
        label: "자산 처분",
        icon: (
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M12 2v20"></path>
                <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"></path>
            </svg>
        ),
    },
    {
        id: "history",
        label: "정비 내역",
        disabled: true,
        icon: (
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                <polyline points="14 2 14 8 20 8"></polyline>
                <line x1="16" y1="13" x2="8" y2="13"></line>
                <line x1="16" y1="17" x2="8" y2="17"></line>
                <polyline points="10 9 9 9 8 9"></polyline>
            </svg>
        ),
    },
];

export default function MaintenanceLayout({ vehicles }: MaintenanceLayoutProps) {
    const navigate = useNavigate();
    const location = useLocation();
    const [activeTab, setActiveTab] = useState("history");

    // Sync activeTab with URL path
    useEffect(() => {
        if (location.pathname.includes("/linkage/sales")) {
            setActiveTab("sales");
        } else if (location.pathname.includes("/linkage/history")) {
            setActiveTab("history");
        } else {
            setActiveTab("driving");
        }
    }, [location]);

    const handleMenuSelect = (id: string) => {
        setActiveTab(id);
        navigate(`/linkage/${id}`);
    };

    return (
        <div className="maintenance-layout">
            <Sidebar
                title="운영"
                titleIcon={
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <circle cx="12" cy="12" r="3"></circle>
                        <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"></path>
                    </svg>
                }
                menuItems={linkageMenuItems}
                activeItem={activeTab}
                onSelect={handleMenuSelect}
            />
            <div className="maintenance-content" style={{ padding: "0", display: 'flex', flexDirection: 'column' }}>
                <Routes>
                    <Route path="driving" element={<DrivingManagementView vehicles={vehicles} />} />
                    <Route path="history" element={<MaintenanceHistoryView />} />
                    <Route path="sales" element={<SalesValuationView />} />
                    <Route path="*" element={<Navigate to="driving" replace />} />
                </Routes>
            </div>
        </div>
    );
}
